import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Send, CheckCircle } from "lucide-react";
import { usePortfolioRequest } from "@/hooks/profile/usePortfolioRequest";
import { ProfileData } from "@/v2/hooks/profiles/useProfiles";
import { useProfileTracking } from "@/v2/hooks/profiles/useProfileTracking";

interface PortfolioRequestButtonProps {
  username: string;
  profileId: string; // Required profile ID parameter
  profile?: ProfileData;
}

const PortfolioRequestButton: React.FC<PortfolioRequestButtonProps> = ({
  username,
  profileId,
  profile,
}) => {
  const { handlePortfolioRequest, loading } = useProfileTracking();
  const [isRequestSent, setIsRequestSent] = useState(false);

  return (
    <div className="mt-2 flex justify-center">
      {!isRequestSent ? (
        <Button
          onClick={() =>
            handlePortfolioRequest(profile).then((res) => {
              if (res) {
                setIsRequestSent(true);
              }
            })
          }
          disabled={loading.portfolio || isRequestSent}
          variant="outline"
          size="sm"
          className="flex items-center gap-2 mx-auto"
        >
          <Send className="h-4 w-4" />
          Request portfolio
          {loading.portfolio && <span className="ml-2 animate-spin">⏳</span>}
        </Button>
      ) : (
        <div className="flex text-center justify-center items-center gap-2 text-sm text-green-600 dark:text-green-400 mx-auto">
          <CheckCircle className="h-4 w-4" />
          Request sent
        </div>
      )}
    </div>
  );
};

export default PortfolioRequestButton;
